import React from "react";
import { Row, Col } from "antd";

export { default as AvatarCard } from "./AvatarCard";
export { default as InfoSection, type InfoItem } from "./InfoSection";
export { default as StatusBadge, type BadgeStatus } from "./StatusBadge";

interface UserProfileLayoutProps {
  avatarCard: React.ReactNode;
  children: React.ReactNode;
  gutter?: number;
  leftSpan?: number;
  rightSpan?: number;
}

export default function UserProfileLayout({
  avatarCard,
  children,
  gutter = 32,
  leftSpan = 5,
  rightSpan = 19,
}: UserProfileLayoutProps) {
  return (
    <Row gutter={gutter}>
      <Col span={leftSpan}>{avatarCard}</Col>
      <Col span={rightSpan}>{children}</Col>
    </Row>
  );
}
